import React from "react";

const DateTimeDisplay = ({ value }) => {
  return <span>{value < 10 ? `0${value}` : value}</span>;
};

export default DateTimeDisplay;
